import Base from '../../js/_base';

export const events = {
    onSavedSearchChange: 'UX:saved-search-on-change',
};

export default class SavedSearchHandler extends Base {
    get selectors() {
        return {
            saveSearchBtn: 'newSearchSaveButton',
            dialog: 'saveSearchDialog',
            form: 'form',
            successMessage: '.search-result__nav__actions__item .text-success',
            errorMessage: '.search-result__nav__actions__item .text-danger',
            savedSearchPanel: 'saved-search-pane',
            savedSearchBody: '.saved-search__body',
            savedSearchRows: '.saved-search__row',
            hiddenRow: '.saved-search__hidden__row__wrapper .saved-search__row',
            columnValue: '.saved-search__body__item__value',
            queryName: '.saved-search__body__item--query-name',
            savedDate: '.saved-search__body__item--saved-date',
            runDate: '.saved-search__body__item--run-date',
            freq: '.saved-search__body__item--freq',
            runAction: '.saved-search__body__item--actions--run',
            deleteAction: '.saved-search__body__item--actions--delete',
        };
    }

    get elements() {
        return {
            saveSearchBtn: null,
            dialog: null,
            form: null,
            successMessage: null,
            errorMessage: null,
            savedSearchPanel: null,
            savedSearchBody: null,
            hiddenRow: null,
        };
    }

    get classList() {
        return {
            hide: 'd-none',
        };
    }

    get url() {
        // return this.localURL;
        return '/action/doSaveSearch';
    }

    get localURL() {
        return '/specs/libraries/theme-eureka/widgets/search-result/ajax/saved-search.json';
    }

    get goLink() {
        return `/action/doSearch?target=saved&runSaved=`;
    }

    get removeLink() {
        return '/action/doDeleteSearch?searchType=saved&queryId=';
    }

    get savedSearchRows() {
        return this._elements.savedSearchPanel.querySelectorAll(this._selectors.savedSearchRows);
    }

    constructor(wrapper) {
        super();
        this.wrapper = wrapper;
        this._url = this.url;
        this._removeLink = this.removeLink;
        this._goLink = this.goLink;
        this.frequencyLabels = {};
        this.maxSearchQueries = null;
        this.onSavedSearchChange = new Event(events.onSavedSearchChange);
        this.initialize();
        this.addEventListeners();
    }

    initialize() {
        super.initialize();
        this._elements.dialog = document.getElementById(this._selectors.dialog);
        this._elements.saveSearchBtn = document.getElementById(this._selectors.saveSearchBtn);
        this._elements.savedSearchPanel = document.getElementById(this._selectors.savedSearchPanel);
        this._elements.form = this._elements.dialog?.querySelector(this._selectors.form);
        this._elements.successMessage = this.wrapper.querySelector(this._selectors.successMessage);
        this._elements.errorMessage = this.wrapper.querySelector(this._selectors.errorMessage);

        this._elements.savedSearchBody = this._elements.savedSearchPanel?.querySelector(
            this._selectors.savedSearchBody
        );
        this._elements.hiddenRow = this._elements.savedSearchPanel?.querySelector(this._selectors.hiddenRow);
        this.maxSearchQueries = this._elements.savedSearchPanel?.dataset.queries;
        this.frequencyLabels = this._elements.savedSearchPanel?.dataset.frequencyLabels;
    }

    addEventListeners() {
        super.addEventListeners();
        this._elements.form?.addEventListener('submit', ev => {
            ev.preventDefault();
            this.onSaveSearchSubmitHandler(ev).then();
        });
    }

    async onSaveSearchSubmitHandler(e) {
        this._elements.saveSearchBtn.classList.add(this._classList.hide);
        $.ajax({
            type: 'POST',
            url: this._url,
            data: $(e.target).serialize(),
            success: this.saveSearchSuccessHandler.bind(this),
            error: this.saveSearchErrorHandler.bind(this),
        });
    }

    baseHandler(item) {
        item.classList.remove(this._classList.hide);
        this._elements.saveSearchBtn.classList.remove(this._classList.hide);
        $(this._elements.dialog).modal('toggle').click();
    }

    removeSavedSearchRows() {
        this.savedSearchRows.forEach(item => {
            item.remove();
        });
    }

    saveSearchSuccessHandler(data) {
        this.baseHandler(this._elements.successMessage);
        this.removeSavedSearchRows();
        this.redrawSavedSearchesPanel(data);
    }

    saveSearchErrorHandler() {
        this.baseHandler(this._elements.errorMessage);
    }

    redrawSavedSearchesPanel(jsonData) {
        if (!this._elements.savedSearchPanel) {
            return;
        }
        jsonData.favQueries?.forEach((value, index) => {
            if (index >= this.maxSearchQueries) {
                return;
            }
            this.renderRow(value, index);
        });
        this._elements.savedSearchPanel.dispatchEvent(this.onSavedSearchChange);
    }

    renderRow(item) {
        const body = this._elements.savedSearchBody;
        const row = this._elements.hiddenRow.cloneNode(true);
        this.columns(row, item);
        this.frequencyColumn(row, item);
        this.additionalColumns(row, item);
        this.actions(row, item);
        body.appendChild(row);
    }

    columns(row, item) {
        const {qName, qSavedOn, qLastRun} = item;
        row.querySelector(`${this._selectors.queryName} ${this._selectors.columnValue}`).textContent = qName;
        row.querySelector(`${this._selectors.savedDate} ${this._selectors.columnValue}`).textContent = qSavedOn;
        row.querySelector(`${this._selectors.runDate} ${this._selectors.columnValue}`).textContent = qLastRun;
    }

    additionalColumns(row, item) {}

    frequencyColumn(row, {qAlertStatus}) {
        let frequency = qAlertStatus;
        if (this.frequencyLabels && this.frequencyLabels[frequency]) {
            frequency = this.frequencyLabels[frequency];
        }
        row.querySelector(`${this._selectors.freq} ${this._selectors.columnValue}`).textContent = frequency;
    }

    actions(row, {qId}) {
        row.querySelector(this._selectors.runAction)?.setAttribute('href', this._removeLink + qId);
        row.querySelector(this._selectors.deleteAction)?.setAttribute('href', this._goLink + qId);
    }
}
